// You can write more code here

import { getGameName } from '@/game/gameHelpers';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class unlockedMasteryFeedackPanel
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // blocker
    const blocker = scene.add.image(0, 0, 'placeholder-square');
    blocker.scaleX = 99;
    blocker.scaleY = 99;
    blocker.alpha = 0.3;
    blocker.alphaTopLeft = 0.3;
    blocker.alphaTopRight = 0.3;
    blocker.alphaBottomLeft = 0.3;
    blocker.alphaBottomRight = 0.3;
    blocker.tintTopLeft = 0;
    blocker.tintTopRight = 0;
    blocker.tintBottomLeft = 0;
    blocker.tintBottomRight = 0;
    this.add(blocker);

    // iconContainer
    const iconContainer = scene.add.container(-528, -384);
    this.add(iconContainer);

    // gameIcon
    const gameIcon = scene.add.image(528, 368, 'ui-pip-mysticMatch');
    gameIcon.scaleX = 8;
    gameIcon.scaleY = 8;
    iconContainer.add(gameIcon);

    // titleText
    const titleText = scene.add.bitmapText(
      528,
      168,
      'Pixellari',
      'New Minigame Mastered!',
    );
    titleText.setOrigin(0.5, 0.5);
    titleText.tintTopLeft = 15130076;
    titleText.tintTopRight = 15130076;
    titleText.tintBottomLeft = 15130076;
    titleText.tintBottomRight = 15130076;
    titleText.text = 'New Minigame Mastered!';
    titleText.fontSize = -32;
    iconContainer.add(titleText);

    // gameNameText
    const gameNameText = scene.add.bitmapText(
      528,
      544,
      'Pixellari',
      'Word Weaver',
    );
    gameNameText.setOrigin(0.5, 0.5);
    gameNameText.tintTopLeft = 15130076;
    gameNameText.tintTopRight = 15130076;
    gameNameText.tintBottomLeft = 15130076;
    gameNameText.tintBottomRight = 15130076;
    gameNameText.text = 'Word Weaver';
    gameNameText.fontSize = -24;
    iconContainer.add(gameNameText);

    this.gameIcon = gameIcon;
    this.titleText = titleText;
    this.gameNameText = gameNameText;

    /* START-USER-CTR-CODE */
    this.gameIcon.setVisible(false);
    /* END-USER-CTR-CODE */
  }

  private gameIcon: Phaser.GameObjects.Image;
  private titleText: Phaser.GameObjects.BitmapText;
  private gameNameText: Phaser.GameObjects.BitmapText;

  /* START-USER-CODE */

  static isShowingMasteryFeedback: boolean = false;

  setGame(game: string | null) {
    if (!game) {
      this.setVisible(false);
      return;
    }
    this.gameNameText.text = getGameName(game) || '';
    this.gameIcon.setVisible(true);
    this.gameIcon.setTexture('ui-pip-' + game);
    // Get the icon for the specific game and set it for gameIcon.
    // Start a feedback tween.
    unlockedMasteryFeedackPanel.isShowingMasteryFeedback = true;

    const feedbackTween = this.scene.tweens.chain({
      targets: this.gameIcon,
      tweens: [
        {
          scale: 0,
          duration: 0,
        },
        {
          delay: 200,
          scale: 8,
          duration: 1000,
          ease: 'Bounce.EaseOut',
        },
        {
          x: 928,
          y: 32,
          scale: 0,
          delay: 500,
          duration: 500,
        },
      ],
    });
    feedbackTween.play();

    this.scene.tweens.add({
      targets: [this.gameNameText, this.titleText],
      alpha: 0,
      duration: 400,
      delay: 2000,
      onComplete: () => {
        this.setVisible(false);
        unlockedMasteryFeedackPanel.isShowingMasteryFeedback = false;
      },
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
